var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMov(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m83.377 31.952v51.385c0 4.785-3.879 8.664-8.664 8.664h-53.427c-4.785 0-8.664-3.879-8.664-8.664v-70.673c.001-4.785 3.879-8.664 8.664-8.664h35.784z",
    fill: "#f4a93c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.377 31.952h-20.531c-3.19 0-5.776-2.586-5.776-5.776v-22.176z",
    fill: "#ffc67b"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27.739 52.839 3.852 11.997 3.835-11.997h5.471v17.243h-4.167v-4.027l.4-8.241-4.168 12.268h-2.747l-4.18-12.279.4 8.252v4.027h-4.157v-17.243z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.141 61.813c0 1.686-.31 3.176-.936 4.467-.62 1.297-1.506 2.29-2.657 2.989s-2.459 1.049-3.926 1.049c-1.472 0-2.775-.338-3.909-1.01-1.139-.677-2.025-1.641-2.662-2.899-.632-1.252-.97-2.696-.998-4.321v-.97c0-1.692.31-3.181.931-4.473.62-1.292 1.506-2.29 2.662-2.989 1.156-.705 2.476-1.055 3.954-1.055 1.461 0 2.764.344 3.909 1.038 1.145.699 2.031 1.686 2.668 2.967.637 1.286.959 2.758.965 4.416v.791zm-4.225-.722c0-1.709-.288-3.012-.863-3.903-.57-.886-1.388-1.331-2.454-1.331-2.087 0-3.187 1.562-3.305 4.693l-.011 1.263c0 1.692.276 2.989.84 3.898.558.908 1.393 1.365 2.499 1.365 1.049 0 1.856-.446 2.425-1.337.57-.897.857-2.177.869-3.852z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.72 65.394 3.435-12.556h4.648l-5.804 17.243h-4.552l-5.753-17.243h4.608z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMov);
export default __webpack_public_path__ + "static/media/mov.9c4f2da8a94b3465bbae4b048658369d.svg";
export { ForwardRef as ReactComponent };